export default "__VITE_ASSET__BFMcASNz__"